<template lang="pug">
	div
		.sfc-container-redesign-v1
			sfc-sentry
			sfc-hello-bar-v3
			sfc-wisepops
			sfc-gtm-body
			sfc-dfp
			sfc-heap
			sfc-enroll-now-urgency-widget(:inPage="false")
			sfc-menu
			sfc-menu-mobile
			sfc-onboarding-modal-v2
			sfc-header
			sfc-login
			sfc-forgot-password
			main#sfc-main-content-new(role="main")
				nuxt
			//- no-ssr(v-if="!userSubscribed()")
			//- 	b-row#bottom-ad
			//- 		.col-md-12.col-sm-12.col-xs-12.ad-align-center
			//- 			.bottom-banner(style="")
			//- 				sfc-dfp-ad(ad-unit="savingforcollege_other_bottom_leaderboard" sizes="[[600,230], [728,90]]")

			//- sfc-blue-box(heading-desktop="A good place to start:" subheading-desktop="See the best 529 plans, personalized for you" heading-mobile="A good place to start:" subheading-mobile="See the best 529 plans, personalized for you" button-text="Get Started" @callback="openSavingsCenter();trackFindYourPlanClickEvent()" :loading="false" :white-button="true")
			sfc-footer
			no-ssr
				sfc-gdpr-banner
			no-ssr
				sfc-modal-trigger
			no-ssr
				enroll-now-modal
		no-ssr
			sfc-college-savings-questions-modal
</template>

<style lang="stylus" scoped>
@import '~assets/css/variables.styl'
	.sfc-blank-layout
		>>> .sfc-container
			width: 100%
	>>> .top-sponsor-container
		&.collapsed
			min-height: 0px
			height: 0px

	>>> .top-sponsor-container-mobile
		&.collapsed
			min-height: 0px
			height: 0px

	#bottom-ad
		background: #f8f8f8
		border: none !important
		.bottom-banner
			text-align: center
			padding: 24px 0
			@media (max-width: 767px)
				padding: 16px 0
	.sfc-blue-box
		@media (max-width: 992px)
			display: none
	#footer
		border-top: 0
</style>

<script>
import SfcWisepops from '@/layouts/common/sfc-wisepops.vue'
import SfcHeader from '@/layouts/common/redesign-v1/sfc-header'
import SfcFooter from '@/layouts/common/redesign-v1/sfc-footer'
import SfcModalTrigger from '@/common/components/modals/modal-trigger'
import EnrollNowModal from '@/common/components/modals/enroll-now-modal'
import sfcCollegeSavingsQuestionsModal from '@/common/components/path/sfc-college-savings-questions-modal'
import SfcHelloBarV3 from '@/common/components/hello-bar/sfc-hello-bar-v3'
import SfcEnrollNowUrgencyWidget from '@/common/components/redesign-v1/sfc-enroll-now-urgency-widget'
import SfcMenu from '@/layouts/common/redesign-v1/sfc-menu-v2'
import SfcMenuMobile from '@/layouts/common/redesign-v1/sfc-menu-mobile-v2'
import SfcLogin from '@/common/components/sfc-login-modal'
import SfcForgotPassword from '@/common/components/sfc-forgot-password-modal'
import SfcOnboardingModalV2 from '@/common/components/savings-center/v3/onboarding/modal-v2'
import SfcBlueBox from '@/common/components/redesign-v1/sfc-blue-box'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {
	components: {
		SfcWisepops,
		SfcHeader,
		SfcFooter,
		SfcModalTrigger,
		sfcCollegeSavingsQuestionsModal,
		EnrollNowModal,
		SfcHelloBarV3,
		SfcEnrollNowUrgencyWidget,
		SfcMenu,
		SfcMenuMobile,
		SfcLogin,
		SfcForgotPassword,
		SfcOnboardingModalV2,
		SfcBlueBox,
		SfcTrackingService
	},
	methods: {
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		},

		trackFindYourPlanClickEvent(){
			SfcTrackingService.trackAnalyticsAction("Savings Center Navigation", "click", "SPA Find your plan widget", 0)
		},

		async openSavingsCenter(){
			let nextPageUrl = false

			// this.savingsCenterFlow = true

			nextPageUrl = await this.nextStep()

			if(nextPageUrl){
				window.location.href = nextPageUrl
			}else{
				setTimeout(()=>{
					this.$sfcModal.open("sfc-onboarding-modal-v3-2", {savingsCenterFlow: true})
				},0)
			}
		},

		async nextStep(){
			let token = this.$cookies.get("sfc_primary")
			let collegeSavingsUser = undefined

			if (token){
				if (this.$store.state.collegeSavingsUserOnboarding  && this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]){
					return "/savings-center/" + this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
				}
			}
			else{
				return false
			}

			const query = `
				query{
					no_graphql_cache()
					college_savings_user_v3(sfc_token: "${token}"){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`

			this.loading = true
			try {
				let result = await this.$httpService.graphql(query)
				collegeSavingsUser = result.data.college_savings_user_v3
			} catch (e) {
				collegeSavingsUser = undefined
			}
			this.loading = false

			if(!collegeSavingsUser)	return false

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

			return "/savings-center/" + collegeSavingsUser.next_step_v3
		}

	}
}
</script>
